import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import PageLoader from './components/PageLoader';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import MissionVision from './pages/MissionVision';
import HowItWorks from './pages/HowItWorks';
import Marketplace from './pages/Marketplace';
import ImpactMetrics from './pages/ImpactMetrics';
import Partners from './pages/Partners';
import Legal from './pages/Legal';
import Contact from './pages/Contact';
import Login from './pages/Login';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminFarmers from './pages/admin/AdminFarmers';
import AdminSuppliers from './pages/admin/AdminSuppliers';
import AdminRiskScores from './pages/admin/AdminRiskScores';
import AdminVouchers from './pages/admin/AdminVouchers';
import AdminFinancing from './pages/admin/AdminFinancing';
import AdminInvestors from './pages/admin/AdminInvestors';
import './App.css';

function AppRoutes() {
  const { isAdmin, loading } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/mission-vision" element={<Layout><MissionVision /></Layout>} />
      <Route path="/how-it-works" element={<Layout><HowItWorks /></Layout>} />
      <Route path="/marketplace" element={<Layout><Marketplace /></Layout>} />
      <Route path="/impact-metrics" element={<Layout><ImpactMetrics /></Layout>} />
      <Route path="/partners" element={<Layout><Partners /></Layout>} />
      <Route path="/legal" element={<Layout><Legal /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/login" element={
        !loading && isAdmin ? <Navigate to="/admin" replace /> : <Login />
      } />
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<AdminDashboard />} />
        <Route path="farmers" element={<AdminFarmers />} />
        <Route path="suppliers" element={<AdminSuppliers />} />
        <Route path="risk-scores" element={<AdminRiskScores />} />
        <Route path="vouchers" element={<AdminVouchers />} />
        <Route path="financing" element={<AdminFinancing />} />
        <Route path="investors" element={<AdminInvestors />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PageLoader />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
